import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntentions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "122.000000pt",
	height: "96.000000pt",
	viewBox: "0 0 122.000000 96.000000",
	preserveAspectRatio: "xMidYMid meet",
	id: "svg5806",
	"sodipodi:docname": "intentions.svg",
	"inkscape:version": "1.2.2 (b0a8486, 2022-12-01)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs5810" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview5808",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:document-units": "pt",
			showgrid: "false",
			"inkscape:zoom": 1.84375,
			"inkscape:cx": 81.627119,
			"inkscape:cy": 64,
			"inkscape:window-width": 1309,
			"inkscape:window-height": 456,
			"inkscape:window-x": 2686,
			"inkscape:window-y": 607,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "svg5806"
		}),
		/* @__PURE__ */ _jsx("metadata", {
			id: "metadata5792",
			children: "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.000000,96.000000) scale(0.050000,-0.050000)",
			fill: "#000000",
			stroke: "none",
			id: "g5804",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1230 1712 c-29 -20 -34 -44 -25 -110 l12 -85 -91 7 c-70 4 -96 -2 -113 -29 -41 -63 8 -106 112 -99 l91 7 -11 -167 c-8 -141 -5 -171 24 -195 73 -61 102 -4 95 190 l-6 175 91 -13 c104 -14 152 31 111 107 -18 33 -34 37 -112 27 l-91 -13 13 91 c16 107 -31 158 -100 107z",
					id: "path5794"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M769 1022 c-126 -32 -135 -45 -170 -255 -18 -108 -39 -216 -46 -239 -14 -42 -11 -43 211 -33 189 8 245 3 341 -30 l115 -39 0 244 c0 265 -4 274 -126 326 -74 32 -249 46 -325 26z m177 -135 c-38 -15 -6 -70 34 -57 47 15 83 -35 74 -103 -8 -52 -14 -57 -86 -53 -43 2 -67 -1 -53 -6 43 -19 27 -43 -23 -33 -26 5 -57 28 -68 52 -21 42 -21 42 -23 -7 -1 -40 -6 -44 -21 -20 -27 41 -25 135 3 152 16 10 18 5 6 -14 -14 -24 -12 -24 18 0 19 15 29 33 23 39 -11 11 85 60 120 60 11 0 9 -5 -4 -10z",
					id: "path5796"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1509 1021 c-34 -8 -90 -31 -125 -52 l-64 -38 0 -252 0 -253 115 39 c94 32 153 38 330 31 160 -7 215 -3 215 15 0 14 -13 91 -29 172 -15 81 -34 181 -41 223 -9 54 -26 82 -61 98 -72 33 -75 17 -39 -174 34 -183 29 -223 -19 -159 -28 38 -29 38 -57 1 -38 -52 -49 -28 -77 185 -26 197 -24 194 -148 164z",
					id: "path5798"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M464 823 c-23 -15 -170 -583 -155 -599 3 -3 104 14 224 38 119 24 311 49 427 57 191 12 205 15 151 38 -95 40 -345 49 -506 18 -185 -37 -194 -28 -156 157 36 182 56 308 48 308 -4 0 -19 -8 -33 -17z",
					id: "path5800"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2040 824 c0 -8 15 -111 34 -230 41 -258 40 -259 -150 -219 -160 34 -405 24 -504 -20 l-70 -32 160 -2 c163 -1 556 -61 654 -99 77 -29 77 -21 12 258 -32 138 -62 269 -67 293 -8 39 -69 84 -69 51z",
					id: "path5802"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect6175",
			width: 19.525423,
			height: 17.898304,
			x: 36.203392,
			y: 49.220341
		})
	]
});
export default SvgIntentions;
